import { render, staticRenderFns } from "./UserAccountActivation.vue?vue&type=template&id=7112de1e&"
import script from "./UserAccountActivation.vue?vue&type=script&lang=js&"
export * from "./UserAccountActivation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports